module.exports = __webpack_public_path__ + "media/images/flags/16/Zambia-0badfff4c06056874b184fc4adc6d427.png";